import FeedbackSubmit from './feedbackSubmit';

export default () => {
    const navigator = global.navigator ? global.navigator : null;
    const window = global.window ? global.window : null;
    const feedbackSubmit = new FeedbackSubmit(navigator, window);
    return Object.keys(feedbackSubmit).map(key => store => next => action => feedbackSubmit[key](store, next, action));
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/feedbackSubmitFactory.js